import React from 'react';
import { CaptionText, P3 } from '../../styles/FontStyles';
import { UserImageCircle } from '../../styles/GlobalComponents';
import { color } from '../../styles/GlobalStyles';
import { LevelOneImgName, LevelOneWrap } from './MyTeamBackofficeStyled';

const UserComponent = ({ user }) => {
  return (
    <LevelOneWrap>
      <LevelOneImgName>
        <UserImageCircle
          image={user?.profileImageUrl}
          avatar
          avatarSize='22px'
          size='50px'
          margin='0 0 4px 0'
        />

        <P3 mb='4' color={color.colors.neutral900}>
          <div className='truncated'>
            <div>{user?.username}</div>
          </div>
        </P3>
      </LevelOneImgName>
      <CaptionText color={color.colors.neutral500}>ID: #{user?.id}</CaptionText>
    </LevelOneWrap>
  );
};

export default UserComponent;
